import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Box, Flex, Input, Select, Text } from 'roo-ui/components';
import { FieldError, FieldLabel } from 'components/Form';
import { NAME_TITLES, EMAIL_REGEX } from 'lib/enums/checkout';

const fieldConfig = {
  title: { required: 'Please select title' },
  firstName: {
    required: 'Please enter your first name',
    maxLength: {
      message: 'First name should be less than 80 characters',
      value: 80,
    },
  },
  lastName: { required: 'Please enter your last name' },
  email: {
    required: 'Please enter your email address',
    pattern: {
      value: EMAIL_REGEX,
      message: 'Please enter a valid email address',
    },
    maxLength: {
      message: 'email should be less than 255 characters',
      value: 255,
    },
  },
  phone: {
    required: 'Please enter your phone number',
    maxLength: {
      message: 'Phone number should be less than 40 digits',
      value: 40,
    },
  },
  qffNumber: {
    maxLength: {
      message: 'QFF number should be of 20 digits',
      value: 20,
    },
  },
};

const PersonalDetails = ({ errors, register, setValue }) => {
  const maskPhoneNumber = useCallback(
    (value) => {
      setValue('phoneNumber', value.replace(/[^0-9+ ]/g, ''));
    },
    [setValue],
  );

  return (
    <Box mb={0} pb={0}>
      <Flex flexDirection={['column', 'row']} mb={2}>
        <FieldLabel htmlFor="title" flex="0 0 20%" pr={[0, 4]}>
          Title
          <Select id="title" name="title" ref={register(fieldConfig.title)} error={!!errors.title}>
            <option value="">Select</option>
            {NAME_TITLES.map((title) => (
              <option key={title} value={title}>
                {title}
              </option>
            ))}
          </Select>
          <FieldError error={errors.title} data-testid="title-error" />
        </FieldLabel>
        <FieldLabel htmlFor="firstName" flex="0 0 40%" pr={[0, 4]}>
          First name
          <Input id="firstName" name="firstName" ref={register(fieldConfig.firstName)} error={!!errors.firstName} />
          <FieldError error={errors.firstName} data-testid="first-name-error" />
        </FieldLabel>
        <FieldLabel htmlFor="lastName" flex="1 1 auto">
          Last name
          <Input id="lastName" name="lastName" ref={register(fieldConfig.lastName)} error={!!errors.lastName} />
          <FieldError error={errors.lastName} data-testid="last-name-error" />
        </FieldLabel>
      </Flex>

      <Flex flexDirection="column" width={[1, 2 / 3]}>
        <FieldLabel htmlFor="emailAddress" mb={2}>
          Email address
          <Input id="emailAddress" name="emailAddress" type="email" ref={register(fieldConfig.email)} error={!!errors.emailAddress} />
          <FieldError error={errors.emailAddress} data-testid="email-address-error" />
        </FieldLabel>

        <FieldLabel htmlFor="phoneNumber" mb={2}>
          Phone number
          <Input
            onChange={(e) => maskPhoneNumber(e.target.value)}
            id="phoneNumber"
            name="phoneNumber"
            ref={register(fieldConfig.phone)}
            error={!!errors.phoneNumber}
            mb={0}
          />
          <FieldError error={errors.phoneNumber} data-testid="phone-number-error" />
          <Text color="greys.dusty">Please include your area code</Text>
        </FieldLabel>

        <FieldLabel htmlFor="qffNumber" mb={2}>
          Your Qantas Frequent Flyer number
          <Input id="qffNumber" name="qffNumber" type="text" ref={register(fieldConfig.qffNumber)} error={!!errors.qffNumber} mb={0} />
          <FieldError error={errors.qffNumber} data-testid="qff-number-error" />
          <Text color="greys.dusty">Optional</Text>
        </FieldLabel>
      </Flex>
    </Box>
  );
};

PersonalDetails.propTypes = {
  errors: PropTypes.object,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

PersonalDetails.defaultProps = {
  errors: {},
};

export default PersonalDetails;
